import { Typography } from "@mui/material";
import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 268.5px;
  min-height: 148px;
  border-radius: 16px;
  padding: 24px 16px;
  background-color: ${(props) => props?.theme.colors[props?.$color ?? "white"]};
  gap: 12px;
  box-sizing: border-box;

  @media (max-width: 600px) {
    width: 216px;
    min-height: 99px;
    height: 99px;
    gap: 9px;
    border-radius: 12px;
    padding: 24px 14px;
  }
`;

export const NumberStyled = styled(Typography)`
  font-weight: 700;
  font-size: 42.37px;
  line-height: 100%;
  text-align: center;
  color: ${(props) => props?.theme.colors?.dark};
  @media (max-width: 600px) {
    font-size: 27px;
  }
`;

export const TextStyled = styled(Typography)`
  font-weight: 500;
  font-size: 23.37px;
  line-height: 100%;
  text-align: center;
  color: ${(props) => props?.theme.colors?.dark};
  white-space: pre-line;
  @media (max-width: 600px) {
    font-size: 15px;
  }
`;

